<template>
  <div class="research-thumb"
       :class="{ unclickable: !item.canBeUnequipped && item.isEquipped}"
       :title="`${item.research.name} (${item.research.displayPermanence}. ${item.research.displayDuration}.)`"
       @click="item.toggleEquip()">
    <img class="research-thumb-img"
         :src="item.research.image"
         :class="{ equipped: item.isEquipped, permanent: item.research.effectType.permanence === 'permanent' && !item.isEquipped }"
    />
    <div class="overlay" onselectstart="return false">
      <p v-if="item.equipCost !== 0"> ${{ item.equipCost.toFixed(0) }} </p>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import Research from '@/Research'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import TextButton from '@/components/ui/TextButton.vue'
import Farm from '@/farm/Farm'
import { ResearchItem } from "@/employee/ResearchItem"

@Options({
  components: {
    ValueMeter, TextButton
  },
  props: {
    item: ResearchItem,
    farm: Object
  },
  methods: {
    log(msg: any) {
      console.log(msg)
    }
  },
  computed: {
    lab() {
      return this.farm.state.lab
    }
  }
})
export default class ResearchThumb extends Vue {
  item!: ResearchItem
  farm!: Farm
}
</script>

<style scoped lang="scss">

.research-thumb {
  position: relative;
  cursor: pointer;
  background-color: #260C1A;
  line-height: 0;
}

.research-thumb-img {
  width: 50px;
  height: 50px;
  border: 1px solid black;
  background: $research-thumb-background;
}

.equipped {
  border-color: $highlight-color;
}

.unclickable {
  cursor: default;
}

.permanent {
  border-color: #610000;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  p {
    font-weight: bold;
    text-align: center;
    -webkit-text-stroke: 1px #000000;
    font-size: 1em;
    line-height: 1.25em;
  }
}

</style>
